/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { frontTypeEnumSchema } from "./frontTypeEnumSchema.ts";
import { paymentProviderEnumSchema } from "./paymentProviderEnumSchema.ts";

export const paymentProviderTypeSchema = z
	.object({
		name: z.string(),
		type: paymentProviderEnumSchema.describe(
			"* `ALFA_BANK` - ALFA_BANK\n* `PAYGINE` - PAYGINE\n* `YOOKASSA` - YOOKASSA\n* `TERMINAL` - TERMINAL\n* `CASH` - CASH\n* `YANDEX_BADGE` - YANDEX_BADGE\n* `PAYMENT_TRACKER` - PAYMENT_TRACKER\n* `KASPI` - KASPI",
		),
		front_type: frontTypeEnumSchema.describe(
			"* `SBP` - QR\n* `TERMINAL_BASE` - Банковская карта\n* `CASH` - Наличные\n* `YANDEX_BADGE` - Яндекс Бейдж\n* `PAYMENT_TRACKER` - Браслет",
		),
		description: z.string(),
	})
	.describe("Сериализатор вывода инфо о типах оплаты на устройстве.");
